module.exports = __webpack_public_path__ + "static/media/users-more-svgrepo-com.db89aade.svg";